<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>Заказ {{ entity.description ? entity.description : entity.invoice_id }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CCard>
                        <CCardBody>
                            <!-- { key: 'created_at', label: 'Создан' },
                            { key: 'updated_at', label: 'Обновлен' },
                            { key: 'delivery_price', label: 'Услуги VIP MIRCITY', admin_only: true },
                            { key: 'price', label: 'Услуги партнера' },
                            { key: 'payments', label: 'Оплаты' }, -->
                            <div class="flex items-center mb-2">
                                <span class="w-1/3">Создан</span>
                                <span class="w-2/3">
                                    {{ getCreatedAt(entity.created_at) }}
                                </span>
                            </div>
                            <div class="flex items-center mb-2">
                                <span class="w-1/3">Услуги партнера</span>
                                <span class="w-2/3">
                                    {{ entity.price }}
                                </span>
                            </div>
                            <div class="flex items-center mb-2">
                                <span class="w-1/3">Услуги VIP MIRCITY</span>
                                <span class="w-2/3">
                                    {{ entity.delivery_price }}
                                </span>
                            </div>
                        </CCardBody>
                    </CCard>
                    <CCard>
                        <CCardHeader>
                            <strong>Оплаты</strong>
                        </CCardHeader>
                        <CCardBody>
                            <table class="table">
                                <tr>
                                    <th width="100">Дата</th>
                                    <th>Сумма</th>
                                    <th>Транзакция</th>
                                    <th width="160">Чек</th>
                                    <th width="160"></th>
                                </tr>
                                <tr v-for="item in entity.payments" :key="`payment-${item.id}`">
                                    <td>{{ getCreatedAt(item.created_at) }}</td>
                                    <td>{{ item.amount }}</td>
                                    <td>{{ item.transaction_id }}</td>
                                    <td>
                                        <CInput class="mb-0" v-model="item.receipt_id" placeholder="Id чека"></CInput>
                                        <CButton class="w-full" color="primary" @click="setReceipt(item.id, item.receipt_id)">Проверить чек</CButton>
                                    </td>
                                    <td>
                                        <CButton class="w-full" color="primary" v-if="item.payload" @click="showReceipt(item.payload)">Просмотр чека</CButton>
                                    </td>
                                </tr>
                            </table>
                        </CCardBody>
                    </CCard>
                </CCardBody>
            </CCard>
        </CCol>
        
        <CModal
            class="vip-order-modal"
            :show.sync="payloadModal">
            <template>
                <div slot="header">Состав заказа</div>
                <div slot="body-wrapper" class="modal-body">
                    <table class="table">
                        <tr>
                            <th>Название</th>
                            <th>Услуги партнера</th>
                            <th>Кол-во</th>
                            <th>Сумма</th>
                        </tr>
                        <tr v-for="(item, index) in receiptItems" :key="`receiptItems-${index}`">
                            <td>{{ item.Label }}</td>
                            <td>{{ item.Price }}</td>
                            <td>{{ item.Quantity }}</td>
                            <td>{{ item.Amount }}</td>
                        </tr>
                    </table>
                </div>
                <div slot="footer">
                    <CButton color="error" @click="payloadModal = false">Закрыть</CButton>
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import moment from 'moment';
    import OrdersTable from '@/components/orders/VipOrdersTable';
    import PartnersTabLinks from '@/components/partner/VipPartnersTabLinks';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {

        name: 'PartnerOrders',

        components: {
            PartnersTabLinks,
            OrdersTable,
        },

        data() {
            return {
                entity: undefined,
                items: [],
                total: 1,
                receiptItems: {},
                payloadModal: false
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id, order_id } = this.$route.params;
                this.entity = (await this.axios.get(`/vip-partners/orders/${order_id}`)).data;
            },
            getCreatedAt(created_at) {
                return moment(created_at).format('DD.MM.YYYY HH:mm');
            },
            async setReceipt(payment_id, receipt_id) {
                await this.axios.put(`/vip-partners/payments`, { payment_id, receipt_id });
                await this.fetch();
            },
            async showReceipt(payload) {
                const data = JSON.parse(payload);
                console.log(data);
                if(data && data.Data) {
                    const receipt = JSON.parse(data.Data).CloudPayments?.CustomerReceipt;
                    console.log(receipt);
                    if(receipt && (receipt.Items || receipt.items)) {
                        this.receiptItems = receipt.Items || receipt.items;
                        this.payloadModal = true;
                    }
                }
            }
        },
    };
</script>
